
export default {
  // new Intl.NumberFormat('en-US',{ style: 'currency', currency: 'USD' }).format(money); // '$100.00'
  currentSn: state => state.currentSn,
  refreshRequired: state => state.refreshRequired,
  domesticVoiceAverage12Months: state => state.domesticVoiceAverage12Months,
  domesticDataAverage12Months: state => state.domesticDataAverage12Months,
}
